import type { UnitFloorRoomMapping, UnitFloorRoomMappingApiItem } from '@/types/unit-floor-room-mapping';

export const mapUnitFloorRoomMappingItem = (item: UnitFloorRoomMappingApiItem): UnitFloorRoomMapping => {
    const fallbackRoomRange = `${item.roomStart}-${item.roomEnd}`;
    const resolvedUnitLabelFromDisplay = item.displayLabel?.split(',')[0]?.trim() ?? '';
    const resolvedUnitLabel = item.unitFloor?.trim() || resolvedUnitLabelFromDisplay || 'Unit';

    return {
        id: item.id,
        hospitalId: item.hospitalId,
        unitId: item.unitId,
        unitCode: item.unitCode ?? resolvedUnitLabel,
        unitName: resolvedUnitLabel,
        unitFloor: item.unitFloor ?? '',
        nameOfUnit: item.unitFloor ?? null,
        roomStart: item.roomStart,
        roomEnd: item.roomEnd,
        roomRange: item.roomRange ?? fallbackRoomRange,
        displayLabel: item.displayLabel ?? `${resolvedUnitLabel}, Rooms ${fallbackRoomRange}`,
        isActive: item.isActive,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt
    };
};
